export default function noop() {}



//////////////////
// WEBPACK FOOTER
// /home/daniel/www/navigator.palladium.cz/node_modules/d3-geo/src/noop.js
// module id = ../../../node_modules/d3-geo/src/noop.js
// module chunks = 0